import { 
  StudentAssignmentDetailsProvider 
} from '../../../teacher/classes/pages/student-assignment-details/duck';
import { AssignmentHeader, Footer } from '../../components';
import { useQuery } from '@apollo/client';
import { Button, Flex, VStack } from '@chakra-ui/react';
import { TeacherPages } from '@suit/pages';
import React, {useRef, useState} from 'react';
import { useNavigate, useParams, generatePath } from 'react-router-dom';
import { getQuery } from '@lon/api';
import { Icon } from '@lon/shared/components';
import { sxLightScrollBar } from '@lon/shared/constants';
import { QueryAssignmentArgs } from '@lon/shared/gql/types';
import { useQueryParams } from '@lon/shared/hooks';
import { routes } from '@lon/shared/configs';
import { queries } from './duck';
import { useTranslation } from 'react-i18next';
import { Toolbar } from '@lon/suit/components';

const GradeAssignment = () => {
  const [queryParams] = useQueryParams();
  const toolConsumerCode = (queryParams.get('tool_consumer_code') ||
    '') as string;
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const { data, loading: loadingAssignment } = useQuery<
    queries.AssignmentResponse,
    QueryAssignmentArgs
  >(queries.GET_ASSIGNMENT, {
    variables: {
      // TODO remove replace when backend fix assignmentId
      id: assignmentId?.replace('_', '#'),
    },
  });
  const { t } = useTranslation();
  const [externalSavingGrades, setExternalSavingGrades] = useState(false);
  const externalSavingGradesRef = useRef(false);
  
  const onSaveCallback = (success: boolean) => {
    if (toolConsumerCode === 'schoology' && externalSavingGradesRef.current) {      
      
      if (!success) {
        setExternalSavingGrades(false)
        return;
      }
    
      setTimeout(() => {
        navigate(`${generatePath(routes.lti.showAssignment, {
          assignmentId,
        })}?${getQuery({ ...queryParams })}`);
        setExternalSavingGrades(false)
      }, 3000)
    }
  };

  const saveGradingEvent = new CustomEvent("saveGrading")

  return (
    <StudentAssignmentDetailsProvider
      value={{
        isGoingBack: false,
        isGoingBackRef: {current: false},
        onSaveCallback,
      }}
    >
      <Flex direction="column" height="100vh">
        <AssignmentHeader
          loading={loadingAssignment}
          elementName={
            data?.assignment?.assignmentSource?.element?.elementName || ''
          }
          sectionName={
            data?.assignment?.assignmentSource?.element?.sectionName || ''
          }
          scopeName={data?.assignment?.assignmentSource?.element?.scopeName || ''}
          action={
            toolConsumerCode === 'schoology' && (
              <Button
                size="sm"
                variant="solid"
                alignSelf="center"
                leftIcon={<Icon name="subscription-outlined" />}
                isLoading={externalSavingGrades}
                isDisabled={externalSavingGrades}
                onClick={() => {
                  setExternalSavingGrades(true);
                  externalSavingGradesRef.current = true;
                  window.dispatchEvent(saveGradingEvent);
                }}
              >
                {t('allAssignments.filterGradesPlaceholder')}
              </Button>
            )
          }
        />
        {toolConsumerCode === 'schoology' && (
          <Toolbar isLoading={loadingAssignment} originalPath={routes.lti.gradeAssignment} /> 
        )}
        <VStack
          bgColor="white"
          width="100%"
          gridGap="4"
          p={8}
          borderRadius="md"
          overflow="auto"
          sx={sxLightScrollBar}
          flexGrow="1"
        >
          <TeacherPages.Grading
            backPath={
              toolConsumerCode !== 'schoology'
                ? routes.lti.progressGrading
                : undefined
            }
            isLti
            externalSavingGradesRef={externalSavingGradesRef}
          />
        </VStack>
        <Footer />
      </Flex>
    </StudentAssignmentDetailsProvider>
  );
};

export default GradeAssignment;
